import React from "react";
import "./style.css";
/**
 * Reusable container of Text Area with title
 * @param {string} textAreaType - Message or Notes
 * @param {string} placeholder - Placeholder text for textarea
 * @param {string} value - textarea content
 * @param {function} onChange - Function to handle the textarea content change event
 * @returns
 */
const TextArea = ({ textAreaType, placeholder, value, onChange }) => {
  // const textMap = {
  //   message: "Message",
  //   notes: "Notes",
  //   remarks: "",
  // };
  return (
    <div className="modal-textarea-frame">
      {textAreaType !== "remarks" && (
        <div className="modal-textarea-title">
          {/* {textMap[textAreaType]} */}
          {textAreaType === "message" ? "Message" : "Notes"}
        </div>
      )}
      <textarea
        className="modal-textarea-content-frame"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      ></textarea>
    </div>
  );
};

export default TextArea;
